
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademark-oppositions-landing-page",
      function () {
        return require("private-next-pages/trademark-oppositions-landing-page/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademark-oppositions-landing-page"])
      });
    }
  